const route = [
    {//选择作业类型
        path: '/weiqi/chooseType',
        component: function (resolve) {
            require(['VIEWS/weiqi/choosetype.vue'], resolve);
        }
    },
    {//选择章节
        path: '/weiqi/setBook/:sid/:type/:code',
        component: function (resolve) {
            require(['VIEWS/weiqi/setBook.vue'], resolve);
        }
    },
    {//选择章节
        path: '/weiqi/selectChapter',
        component: function (resolve) {
            require(['VIEWS/weiqi/selectChapter.vue'], resolve);
        }
    },
    {//试题预览
        path: '/weiqi/preview',
        component: function (resolve) {
            require(['VIEWS/weiqi/preview.vue'], resolve);
        }
    },
    {//试题预览
        path: '/weiqi/preview/:taskid',
        component: function (resolve) {
            require(['VIEWS/weiqi/preview.vue'], resolve);
        }
    },
    {//发布作业
        path: '/weiqi/release',
        component: function (resolve) {
            require(['VIEWS/weiqi/release.vue'], resolve);
        }
    },
    {//检查作业详情
        path: '/weiqi/taskDetail/:classid/:taskid',
        component: function (resolve) {
            require(['VIEWS/weiqi/taskdetail.vue'], resolve);
        }
    },
];
export default route
